import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.css']
})
export class EventDetailsComponent implements OnInit {
  news:any=[];
  SingleNews:any
  days: any;
  hours: any;
  minutes: any;
  seconds: any;
  
  constructor(private router: Router , 
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService) {
    }
  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.getDetails();
    this.getSingleDetails(id)
  }

  newsDetails(id:any){
    // window.location.reload();
    // this.router.navigateByUrl("news-detail/" + id);
    this.getSingleDetails(id);

  }

  getTimer(date:any,id:any){
  // Set the date we're counting down to
  var countDownDate = new Date(date).getTime();
  // Update the count down every 1 second
  var x = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
    this.hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
    document.getElementById(id).innerHTML =
      this.days +
      "d " +
      this.hours +
      "h " +
      this.minutes +
      "m " +
      this.seconds +
      "s ";
    console.log(this.days, this.hours, this.minutes, this.seconds);
  }, 1000);
  }

  getSingleDetails(id:any) {
    const url = this.global.basePath + "common/event?modelType=event&id=" + id;
    this.global.GetRequestUnauthorised(url).subscribe((res:any) => {
      const data = res[0].json.event;
      this.SingleNews = data;
      this.getTimer(data.dateTime,data._id)
    });
  }

  getDetails() {
    const url = this.global.basePath +  "common/circularlist?modelType=event";
    this.global.GetRequestUnauthorised(url).subscribe((res:any) => {
      const data = res[0].json.circular;
      this.news = data;
    });
  }

}
